"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextToSpeechApplyTextNormalizationEnum = void 0;
exports.TextToSpeechApplyTextNormalizationEnum = {
    Auto: "auto",
    On: "on",
    Off: "off",
};
